<template>
  <div class="text-center">
    <v-menu offset-y absolute v-model="lmenu" :close-on-content-click="false" :full-width="true">
      <v-btn :depressed="true" slot="activator" block>
        <span v-if="totalGuests === 0" class="caption">Click here to add number of Guests</span>
        <span v-if="totalGuests >= 1" class="caption">{{totalGuests}} Guest{{totalGuests > 1 ? 's' : ''}}</span>
      </v-btn>
      <v-list>
        <v-list-tile row v-for="(guest, key) in allConservationFees" :key="key">
          <v-container>
            <v-layout row>
              <v-flex lg6 md6 sm6 xs6 align-left>
                <p class="body-2" :title="guest.payment_person_description" v-tippy>{{guest.payment_person}} ({{guest.payment_person_currency}} {{guest.payment_person_amount}})</p>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <v-btn-toggle>
                  <v-btn :depressed="true" @click="reduceGuest(key)" dark round small color="error"><v-icon>remove</v-icon></v-btn>
                </v-btn-toggle>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <h4 class="text-md-center text-sm-center text-xs-center">{{guest.payment_guests}}</h4>
              </v-flex>
              <v-flex lg2 md2 sm2 xs2 align-center>
                <v-btn-toggle>
                  <v-btn :depressed="true" @click="addGuest(key)" dark round small color="primary"><v-icon>add</v-icon></v-btn>
                </v-btn-toggle>
              </v-flex>
            </v-layout>
          </v-container>
        </v-list-tile>
        <v-list-tile>
          <v-container>
            <v-layout row wrap>
              <v-flex md4 lg4 sm4 xs12 offset-lg7 offset-md7 offset-sm7 align-center>
                <!-- REMOVED: Apply button - auto-apply now -->
                <v-btn :depressed="true" dark small block color="primary" @click="closeMenu">Close</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-list-tile>
        <br>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
  export default {
    name: 'Guests',
    data() {
      return {
        lmenu: false,
        allConservationFees: []
      }
    },
    computed: {
      totalGuests() {
        if (!this.allConservationFees || this.allConservationFees.length === 0) return 0
        return this.allConservationFees.reduce((total, guest) => {
          return total + (Number(guest.payment_guests) || 0)
        }, 0)
      },
      
      globalGuests() {
        if (this.$store.state.GlobalBookingStore && this.$store.state.GlobalBookingStore.booking_guests) {
          return this.$store.state.GlobalBookingStore.booking_guests
        }
        return { adults: 0, children: 0, total: 0 }
      }
    },
    created() {
      this.initializeGuests()
    },
    methods: {
      initializeGuests() {
        const conservationData = localStorage.getItem('conservation_data')
        if (conservationData && JSON.parse(conservationData).length !== 0) {
          this.allConservationFees = JSON.parse(conservationData)
          if (this.$store.commit) {
            this.$store.commit('LOCAL_CONSERVATION', this.allConservationFees)
          }
        } 
        else if (this.$store.state.ConservationFeeStore && 
                 this.$store.state.ConservationFeeStore.all_conservation_fees && 
                 this.$store.state.ConservationFeeStore.all_conservation_fees.length > 0) {
          this.allConservationFees = JSON.parse(JSON.stringify(this.$store.state.ConservationFeeStore.all_conservation_fees))
          this.allConservationFees.forEach(function(fee) {
            if (!fee.payment_guests) fee.payment_guests = 0
          })
        }
        else if (this.globalGuests && this.globalGuests.total > 0) {
          this.restoreGuestsFromGlobalStore()
        }
        else {
          this.fetchConservationFees()
        }
      },
      
      fetchConservationFees() {
        var self = this
        this.$store.dispatch('get_all_conservation_fees')
          .then(function(response) {
            if (response && response.data) {
              self.allConservationFees = JSON.parse(JSON.stringify(response.data))
              self.allConservationFees.forEach(function(fee) {
                if (!fee.payment_guests) fee.payment_guests = 0
              })
            } else if (self.$store.state.ConservationFeeStore && 
                       self.$store.state.ConservationFeeStore.all_conservation_fees) {
              self.allConservationFees = JSON.parse(JSON.stringify(self.$store.state.ConservationFeeStore.all_conservation_fees))
              self.allConservationFees.forEach(function(fee) {
                if (!fee.payment_guests) fee.payment_guests = 0
              })
            }
          })
          .catch(function(error) {
            console.error('Error fetching conservation fees:', error)
          })
      },
      
      restoreGuestsFromGlobalStore() {
        var self = this
        if (this.allConservationFees && this.allConservationFees.length > 0) {
          this.allConservationFees.forEach(function(fee) {
            if (fee.payment_person && fee.payment_person.toLowerCase().indexOf('adult') !== -1) {
              fee.payment_guests = self.globalGuests.adults || 0
            } else if (fee.payment_person && fee.payment_person.toLowerCase().indexOf('child') !== -1) {
              fee.payment_guests = self.globalGuests.children || 0
            } else {
              fee.payment_guests = 0
            }
          })
        }
      },
      
      reduceGuest(key) {
        if (this.allConservationFees[key] && this.allConservationFees[key].payment_guests > 0) {
          var guest = Number(this.allConservationFees[key].payment_guests) - 1
          this.$set(this.allConservationFees[key], 'payment_guests', guest)
          // Auto-save after change
          this.autoSaveGuests()
        }
      },
      
      addGuest(key) {
        if (this.allConservationFees[key]) {
          var guest = Number(this.allConservationFees[key].payment_guests) + 1
          this.$set(this.allConservationFees[key], 'payment_guests', guest)
          // Auto-save after change
          this.autoSaveGuests()
        }
      },
      
      // NEW: Auto-save without needing Apply button
      autoSaveGuests() {
        localStorage.setItem('conservation_data', JSON.stringify(this.allConservationFees))
        
        if (this.$store.commit) {
          this.$store.commit('LOCAL_CONSERVATION', this.allConservationFees)
        }
        
        var adults = this.calculateTotalAdults()
        var children = this.calculateTotalChildren()
        
        var guests = {
          adults: adults,
          children: children,
          total: adults + children
        }
        
        if (this.$store.dispatch && this.$store.state.GlobalBookingStore) {
          this.$store.dispatch('GlobalBookingStore/updateBookingGuests', guests)
        }
        
        localStorage.setItem('guests', JSON.stringify({
          adults: adults,
          children: children
        }))
        
        // Emit event for other components
        this.$emit('guests-auto-updated', guests)
        
        // Trigger global cart update
        this.$root.$emit('cart-updated')
      },
      
      // NEW: Close menu without applying (already auto-applied)
      closeMenu() {
        this.lmenu = false
      },

      calculateTotalAdults() {
        var adultCount = 0
        this.allConservationFees.forEach(function(fee) {
          const personType = fee.payment_person ? fee.payment_person.toLowerCase() : ''
          const guestCount = Number(fee.payment_guests) || 0
          
          if (personType.includes('child') || personType.includes('infant')) {
            return
          }
          
          if (guestCount > 0 && personType.trim() !== '') {
            adultCount += guestCount
          }
        })
        return adultCount
      },

      calculateTotalChildren() {
        var childCount = 0
        this.allConservationFees.forEach(function(fee) {
          const personType = fee.payment_person ? fee.payment_person.toLowerCase() : ''
          const guestCount = Number(fee.payment_guests) || 0
          
          const childTypes = ['child', 'citizen child', 'non-resident child', 'ea resident child']
          const isChild = childTypes.some(type => personType.includes(type))
          
          const isInfant = personType.includes('infant')
          
          if (isChild && !isInfant && guestCount > 0) {
            childCount += guestCount
          }
        })
        return childCount
      },
      
      calculatedAdults: function() {
        return this.calculateTotalAdults()
      },
      
      calculatedChildren: function() {
        return this.calculateTotalChildren()
      }
    },
    watch: {
      '$store.state.ConservationFeeStore.all_conservation_fees': {
        handler: function(newFees) {
          if (newFees && newFees.length > 0 && this.allConservationFees.length === 0) {
            this.allConservationFees = JSON.parse(JSON.stringify(newFees))
            this.allConservationFees.forEach(function(fee) {
              if (!fee.payment_guests) fee.payment_guests = 0
            })
          }
        },
        deep: true,
        immediate: false
      }
    }
  }
</script>

<style scoped>
</style>
